module.exports = __webpack_public_path__ + "static/media/family-protect.6968c8b3.png";